import { useEffect, useRef } from 'react'
import { showBrowserConfetti, showPendingCelebration } from './celebrationService'

interface CelebrationBootstrapProps {
  userId: string | null
}

export function CelebrationBootstrap({ userId }: CelebrationBootstrapProps) {
  const handledUserRef = useRef<string | null>(null)
  const activeRequestRef = useRef<{ userId: string; controller: AbortController } | null>(null)

  useEffect(() => {
    if (!userId || handledUserRef.current === userId) return

    const controller = new AbortController()
    activeRequestRef.current = { userId, controller }
    const debugConfetti =
      import.meta.env.DEV &&
      new URLSearchParams(window.location.search).get('debug') === 'confetti'
    const celebrationRequest = debugConfetti
      ? showBrowserConfetti()
      : showPendingCelebration(controller.signal)

    void celebrationRequest
      .then(() => {
        if (!controller.signal.aborted) handledUserRef.current = userId
      })
      .catch((error: unknown) => {
        if (controller.signal.aborted) return
        if (import.meta.env.DEV) {
          console.warn('[celebrations] Could not show pending celebration', error)
        }
      })

    return () => {
      controller.abort()
      if (activeRequestRef.current?.controller === controller) {
        activeRequestRef.current = null
      }
    }
  }, [userId])

  return null
}
